import { render, staticRenderFns } from "./bsHeader.vue?vue&type=template&id=12e93c8b&scoped=true"
import script from "./bsHeader.vue?vue&type=script&lang=js"
export * from "./bsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e93c8b",
  null
  
)

export default component.exports